import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import AppRoutes from './routes/AppRoutes';

function App() {
    return (
        <AuthProvider>
            <div className="App">
                <AppRoutes />
                <ToastContainer />
            </div>
        </AuthProvider>
    );
}

export default App;
